import mock from "./apis/MockConfig";

mock.onAny().passThrough();
